import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
import { AuthenticationService } from '@app/auth';
import { Observable, Subject, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgreementsPageService {
  private msg = new Subject<boolean>();
  currentValue = this.msg.asObservable();
  constructor(
    private httpClient: HttpClient,
    private loginService: LoginService,
    public authService: AuthenticationService,
  ) {}

  disableBackBtn(value: boolean) {
    this.msg.next(value);
  }

  getContractForm(zohoRecordId: string, type: string) {
    let decodedToken = Object(this.loginService.decodeToken(this.authService.currentUserValue?.token));
    return this.httpClient.post<any>('/agreement/nrsPayAgreement', {
      zohoRecordId: zohoRecordId,
      contractType: type,
    });
  }

  /* Sending POS Contract data*/
  public sendPOSContract1(body: any): Observable<HttpResponse<any>> {
    console.log('Pos', body);
    return this.httpClient.post(`/agreement/nrsPosAgreement`, body, { observe: 'response' });
  }
  public sendPOSContract(formData: FormData): Observable<HttpResponse<any>> {
    // const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders()
      // .set('Content-Type', 'multipart/form-data')
      // .set('Authorization', 'Bearer ')
      .set('enctype', 'multipart/form-data')
      .set('Accept', 'application/json');

    return this.httpClient.post(`/agreement/nrsPosAgreement`, formData, {
      headers: headers, // Ensure headers are passed as an object
      observe: 'response', // This option is correct
    });
  }

  agreementFileDownload(orderInfoId: number, requestId: string) {
    return this.httpClient.post<Blob>(
      '/agreement/download/nrsPay',
      {
        orderInfoId: orderInfoId,
        requestId: requestId,
      },
      {
        responseType: 'blob' as 'json', // Set response type to 'blob'
      },
    );
  }

  public getPOSContract(orderInfoId: number) {
    return this.httpClient.get<any>('/agreement/download/nrsPos/' + orderInfoId, {
      responseType: 'blob' as 'json', // Set response type to 'blob'
    });
  }

  //zoho pos contract link
  public getPosContractLink(body: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Origin': window.location.origin
  });

  return this.httpClient.post<any>(
 `/agreement/pos-contract/link`,
    body,
    { headers: headers }
  );
}

 //zoho pos contract polling status
 getContractStatus(unifiedOrderId: number, secureToken: string) {
  return this.httpClient.get(
    `/agreement/status/${unifiedOrderId}/${secureToken}`
  );
}

 //savecontract to db pos 
 saveContractToDB(unifiedOrderId: number, secureToken: string) {

    const params = new HttpParams()
      .set('unifiedOrderId', unifiedOrderId)
      .set('secureToken', secureToken);

    return this.httpClient.post(
      `/agreement/pos-contract/savingContractToDB`,
      null,
      { params }
    );
  }

  //sendingramjson to backend for pos contract
  sendRamJsonToSNS(ramJsonString: string, secureToken: string) {
  const formData = new FormData();
  formData.append('model', ramJsonString);
  formData.append('secureToken', secureToken);

  return this.httpClient.post('/agreement/sns-status', formData);
}

//download zoho pos contract
downloadPosContract(unifiedOrderId: string, secureToken: string): Observable<Blob> {

  const url = `/agreement/pos-contract/download/${unifiedOrderId}/${secureToken}`;
  return this.httpClient.get(url, { responseType: 'blob' });
}

}
